import { useNavigate } from "react-router";
import style from "./style.module.scss";

type TypeCardType = {
  title: string;
  iconUri: string;
  path?: string;
};

export const TypeCard = ({ iconUri, title, path }: TypeCardType) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    path && navigate(path);
  };

  return (
    <div className={style.type_card__wrapper} onClick={handleNavigate}>
      {window.innerWidth > 1024 && (
        <div className="">
          <img src={iconUri} alt={title} className={style.type_card__icon} />
        </div>
      )}
      <div className="" style={{ minWidth: 0 }}>
        <span className={style.type_card__title}> {title} </span>
      </div>
    </div>
  );
};
